document.addEventListener('DOMContentLoaded', function () {
    const initVariantAvailability = () => {
        const productSections = document.querySelectorAll('[data-section-type="product"]');

        productSections.forEach(section => {
            const productJsonElement = section.querySelector('[data-product-json]');
            if (!productJsonElement) return;

            let variants;
            try {
                const jsonData = JSON.parse(productJsonElement.innerHTML);
                variants = jsonData.product && jsonData.product.variants;
            } catch (e) {
                console.warn('[VariantAvailability] Could not parse product JSON', e);
                return;
            }

            if (!variants || !variants.length) return;

            const form = section.querySelector('.ProductForm');
            if (!form) return;

            const getOptionContainers = () =>
                Array.from(form.querySelectorAll('.ProductForm__Option')).filter(
                    el => !el.classList.contains('no-js')
                );

            const getSelected = (container) => {
                const checked = container.querySelector('input[type="radio"]:checked');
                return checked ? checked.value : null;
            };

            /**
             * Check if there is at least one available variant matching the given combination.
             * optionValues: { 1: 'Size S', 2: 'Red', 3: null } — null means "any".
             */
            const hasAvailableVariant = (optionValues) => {
                return variants.some(v => {
                    if (!v.available) return false;
                    if (optionValues[1] != null && v.option1 !== optionValues[1]) return false;
                    if (optionValues[2] != null && v.option2 !== optionValues[2]) return false;
                    if (optionValues[3] != null && v.option3 !== optionValues[3]) return false;
                    return true;
                });
            };

            const setSwatchAvailability = (input, label, isAvailable) => {
                if (!label) return;
                if (isAvailable) {
                    label.classList.remove('is-sold-out', 'soldout');
                    input.disabled = false;
                } else {
                    label.classList.add('is-sold-out', 'soldout');
                    input.disabled = true;
                }
            };

            const updateAvailability = () => {
                const optionContainers = getOptionContainers();
                const numOptions = optionContainers.length;

                const selected = {
                    1: getSelected(optionContainers[0]) || null,
                    2: numOptions >= 2 ? getSelected(optionContainers[1]) || null : null,
                    3: numOptions >= 3 ? getSelected(optionContainers[2]) || null : null
                };

                // ——— 1 OPTION ———
                if (numOptions === 1) {
                    const container = optionContainers[0];
                    container.querySelectorAll('input[type="radio"]').forEach(input => {
                        const value = input.value;
                        const label = form.querySelector(`label[for="${input.id}"]`);
                        const available = hasAvailableVariant({ 1: value, 2: null, 3: null });
                        setSwatchAvailability(input, label, available);
                    });
                    return;
                }

                // ——— 2 OPTIONS ———
                if (numOptions === 2) {
                    // First option: never soldout
                    optionContainers[0].querySelectorAll('input[type="radio"]').forEach(input => {
                        const label = form.querySelector(`label[for="${input.id}"]`);
                        setSwatchAvailability(input, label, true);
                    });

                    // Second option: soldout if no variant (selected[1], thisValue) is available
                    optionContainers[1].querySelectorAll('input[type="radio"]').forEach(input => {
                        const value = input.value;
                        const label = form.querySelector(`label[for="${input.id}"]`);
                        const available = hasAvailableVariant({
                            1: selected[1],
                            2: value,
                            3: null
                        });
                        setSwatchAvailability(input, label, available);
                    });
                    return;
                }

                // ——— 3 OPTIONS ———
                if (numOptions >= 3) {
                    // First option: never soldout
                    optionContainers[0].querySelectorAll('input[type="radio"]').forEach(input => {
                        const label = form.querySelector(`label[for="${input.id}"]`);
                        setSwatchAvailability(input, label, true);
                    });

                    // Second option: soldout if no variant (selected[1], thisValue, *) is available
                    optionContainers[1].querySelectorAll('input[type="radio"]').forEach(input => {
                        const value = input.value;
                        const label = form.querySelector(`label[for="${input.id}"]`);
                        const available = hasAvailableVariant({
                            1: selected[1],
                            2: value,
                            3: null
                        });
                        setSwatchAvailability(input, label, available);
                    });

                    // Third option: soldout if no variant (selected[1], selected[2], thisValue) is available
                    optionContainers[2].querySelectorAll('input[type="radio"]').forEach(input => {
                        const value = input.value;
                        const label = form.querySelector(`label[for="${input.id}"]`);
                        const available = hasAvailableVariant({
                            1: selected[1],
                            2: selected[2],
                            3: value
                        });
                        setSwatchAvailability(input, label, available);
                    });
                }
            };

            form.addEventListener('change', (e) => {
                if (e.target.matches('input[type="radio"]')) {
                    setTimeout(updateAvailability, 0);
                }
            });

            updateAvailability();
        });
    };

    initVariantAvailability();
    document.addEventListener('shopify:section:load', initVariantAvailability);
});
